import { FieldBase } from '@/components/form';
import { useEinstellungenFormContext } from '@/domain/controlling/pages/Umsatzplanung/Einstellungen/Forms/EinstellungenForm/useEinstellungenFormContext';
import { useTranslation } from 'react-i18next';
import { AbsatzProduktivitaetWithAbsatzVorgabeOptions } from './AbsatzProduktivitaetWithAbsatzVorgabeOptions';
import { AbsatzVorgabe } from '@/domain/controlling/entities';

export function AbsatzProduktivitaetForm() {
  const { t } = useTranslation();

  const form = useEinstellungenFormContext();

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        e.stopPropagation();
        form.handleSubmit();
      }}
      className="flex flex-col gap-2">
      <form.AppField name="zielProduktivitaetAbsatz">
        {(field) => (
          <FieldBase
            label={t(
              'domain.controlling.umsatzplanung.einstellungen.inputs.zielProduktivitaetAbsatz.label',
            )}>
            <AbsatzProduktivitaetWithAbsatzVorgabeOptions
              isValid={field.state.meta.isValid}
              onInput={(e) => {
                field.handleChange((prev) => ({
                  unit: prev?.unit ?? AbsatzVorgabe.Stueck,
                  value: e.currentTarget.value,
                }));
              }}
              onOptionsChange={(value) => {
                field.handleChange((prev) => ({
                  value: prev?.value ?? '',
                  unit: value,
                }));
              }}
              onBlur={field.handleBlur}
              defaultInputValue={field.state.value?.value ?? ''}
              defaultOption={field.state.value?.unit ?? AbsatzVorgabe.Stueck}
            />
          </FieldBase>
        )}
      </form.AppField>
    </form>
  );
}
